import { AUTO_HIDE, CONTROLS, FS, LOOP, MODEST_BRANDING, REL, SHOW_INFO, } from '@yme/atoms/video-player';
import { ENABLE_JS_API } from '@yme/utils/constants';
export const DEFAULT_CONFIG_PARAM = [
    `${ENABLE_JS_API}=1`,
    `${CONTROLS}=1`,
    `${AUTO_HIDE}=1`,
    `${MODEST_BRANDING}=1`,
    `${SHOW_INFO}=0`,
    `${LOOP}=1`,
    `${REL}=0`,
    `${FS}=1`,
];
